<div class="npdc-title">
  <h1>Users</h1>
  <div class="npdc-title__actions">
    <button mat-flat-button (click)="create()">New user</button>
  </div>
</div>

<div class="npdc-search">
  <div class="npdc-search__input">
    <div class="npdc-search__input__prefix">
      <mat-icon>search</mat-icon>
    </div>
    <input
      type="search"
      placeholder="Search in users..."
      [value]="q()"
      (keydown.enter)="onSearchEvent($event)"
    />
  </div>
</div>

@if (usersList.selectedOptions.selected.length) {
  @let user = getUser(usersList.selectedOptions.selected[0]);
  @if (user) {
    <p>
      @if (user.status === 'active' || user.status === 'pending') {
        @if (!isDirectoryUser(user)) {
          <button mat-flat-button (click)="recover(user)">Recover</button>
        }
        <button mat-button (click)="toggleStatus(user)">Disable</button>
      } @else {
        <button mat-flat-button (click)="toggleStatus(user)">Enable</button>
      }
    </p>
  }
}

<app-list [resource]="users">
  <mat-selection-list #usersList [multiple]="false">
    @if (!users.error()) {
      @for (user of users.value()?.items; track user.id) {
        <mat-list-option [value]="user.id" togglePosition="before">
          <span matListItemTitle>{{ user.email }}</span>
          <span matListItemLine>{{ user.accessLevel }}</span>
          <span matListItemLine>{{ user.status }}</span>
        </mat-list-option>
      }
    }
  </mat-selection-list>

  @if (!users.error()) {
    <mat-paginator
      showFirstLastButtons
      (page)="onPageEvent($event)"
      [length]="users.value()?.count"
      [pageIndex]="page()"
      [pageSize]="pageSize()"
      [pageSizeOptions]="[10, 20, 50, 100]"
    >
    </mat-paginator>
  }
</app-list>
